import React, { Component } from 'react';
import { Button, Dialog, Pane, TextInputField } from 'evergreen-ui';
import DatePicker from "react-datepicker";
import moment from 'moment';
import Request from '../../../util/Api';

const downloadInvoices = async (start, end) => {
    const data = await Request.get(`/orders-bulk/invoice-export?start=${start.format('YYYY-MM-DD')}&end=${end.format('YYYY-MM-DD')}`);
    const file_path = data.data;
    var a = document.createElement('A');
    a.href = file_path;
    a.download = data.filename;
    document.body.appendChild(a);
    a.click();
}

const downloadInvoiceReport = async (start, end) => {
    const data = await Request.get(`/reports/invoices?start=${start.format('YYYY-MM-DD')}&end=${end.format('YYYY-MM-DD')}`);
    const file_path = data.data;
    var a = document.createElement('A');
    a.href = file_path;
    a.download = data.filename;
    document.body.appendChild(a);
    a.click();
}

const downloadAccountInvoiceReport = async (start, end) => {
    const data = await Request.get(`/reports/sale-report-per-account?start=${start.format('YYYY-MM-DD')}&end=${end.format('YYYY-MM-DD')}`);
    const file_path = data.data;
    var a = document.createElement('A');
    a.href = file_path;
    a.download = data.filename;
    document.body.appendChild(a);
    a.click();
}

const downloadAccountingReport = async (start, end) => {
    const data = await Request.get(`/reports/accounting?start=${start.format('YYYY-MM-DD')}&end=${end.format('YYYY-MM-DD')}`);
    const file_path = data.data;
    var a = document.createElement('A');
    a.href = file_path;
    a.download = data.filename;
    document.body.appendChild(a);
    a.click();
}


class IntervalModal extends Component {
    constructor (props) {
        super(props);

        this.state = {
            start: moment(),
            end: moment()
        }

        this.onClose = this.onClose.bind(this);
    }

    onClose = () => {
        this.props.onClose();
    }

    render () {
      return (<Dialog
        shouldCloseOnOverlayClick={false}
        width={800}
        isShown={this.props.open}
        title= {"Descarca NIR-uri pentru interval"}
        hasFooter={false}
        onCloseComplete={this.onClose}
        onClose={this.onClose}>
            <Pane>
                <DatePicker
                    marginBottom={0}
                    dateFormat="dd/MM/yyyy"
                    selected={moment(this.state.start).toDate() || null}
                    onChange={value =>
                        this.setState({
                            start: moment(value).isValid() ? moment(value) : moment()
                        })
                    }
                    customInput={<TextInputField
                        label="Data Inceput"
                    />}
                />

                <DatePicker
                    marginBottom={0}
                    dateFormat="dd/MM/yyyy"
                    selected={moment(this.state.end).toDate() || null}
                    onChange={value =>
                        this.setState({
                            end: moment(value).isValid() ? moment(value) : moment()
                        })
                    }
                    customInput={<TextInputField
                        label="Data Sfarsit"
                    />}
                />

            </Pane>
            
            <Button marginRight={10} type="button" onClick={() => {
                this.props.onClose();
            }}>Inchide</Button>

            <Button marginRight={10} type="button" onClick={() => {
                downloadInvoiceReport(this.state.start, this.state.end);
            }}>Descarca Raport</Button>

            <Button marginRight={10} type="button" onClick={() => {
                downloadAccountInvoiceReport(this.state.start, this.state.end);
            }}>Descarca Raport pe Gestiuni</Button>

            <Button marginRight={10} type="button" onClick={() => {
                downloadInvoices(this.state.start, this.state.end);
            }}>Descarca Arhiva Facturi</Button>

            <Button marginRight={10} type="button" onClick={() => {
                downloadAccountingReport(this.state.start, this.state.end);
            }}>Descarca Raport Vanzari Contabilitate</Button>
      </Dialog>)
    }
}

export default IntervalModal;